<script setup>
import { Toggle, Icon, Card, TimePicker, Dropdown, Checkbox, Button } from '@components'
import moment from 'moment'
// import HoursEdit from './HoursEdit.vue'

import { computed ,ref} from 'vue'

// Settings store.
import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRouter, useRoute } from 'vue-router'
const route = useRoute()
const router = useRouter()

const saveBusinessHours = async () => {
    Log('working hours', $settings.businessHours)
    const saved = await $settings.saveSettings('business_hours', $settings.businessHours)
    Log('saved', saved)
    Toast.success('Updated working hours')
    prebook_admin.setup.hours_updated = true

    if (route.query.dashboard) {
        router.push({ name: 'dashboard' })
    }
}

const isScheduleEnabled = (value) => {
    return [true, 'true', 1, '1', 'yes'].includes(value)
}
const toggleSchedule = (day) => {
    $settings.businessHours[day].enabled = isScheduleEnabled($settings.businessHours[day].enabled) ? false : true

    if ($settings.businessHours[day].enabled) {
        $settings.businessHours[day].hours = $settings.businessHours[day].hours || []
        if ($settings.businessHours[day].hours.length === 0) {

            const newSlot = {
                start: '9:00 AM',
                end: '5:00 PM'
            }
            $settings.businessHours[day].hours.push(newSlot)
        }
    }
}

// Slot actions.
const removeSlot = (day, index) => {
    $settings.businessHours[day].hours.splice(index, 1)

    if ($settings.businessHours[day].hours.length === 0) {
        $settings.businessHours[day].enabled = false
    }
}

const addSlot = (day) => {

    // Previous slot of the same day or previous day.
    let previousSlot = $settings.businessHours[day].hours[$settings.businessHours[day].hours.length - 1]
    if (!previousSlot) {
        const previousDay = $settings.businessHours[Object.keys($settings.businessHours)[Object.keys($settings.businessHours).indexOf(day) - 1]]
        if (previousDay && previousDay.enabled) {
            previousSlot = previousDay.hours[previousDay.hours.length - 1]
        }
    }

    $settings.businessHours[day].hours.push({
        start: previousSlot ? previousSlot.end : '9:00 AM',
        end: previousSlot ? moment(previousSlot.end, 'h:mm A').add(1, 'hour').format('h:mm A') : '5:00 PM'
    })
}

const cloneSlot = (day,selectedDays) => {
    
    selectedDays.forEach(d => {
        if(d==day) return
        $settings.businessHours[d] = {
            enabled: true,
            hours: [...$settings.businessHours[day].hours] || []
        }
    })

    activeCloneDay.value = ''
    // let previousSlot = $settings.businessHours[day].hours[$settings.businessHours[day].hours.length - 1]
    // if (!previousSlot) {
    //     const previousDay = $settings.businessHours[Object.keys($settings.businessHours)[Object.keys($settings.businessHours).indexOf(day) - 1]]
    //     if (previousDay && previousDay.enabled) {
    //         previousSlot = previousDay.hours[previousDay.hours.length - 1]
    //     }
    // }

    // $settings.businessHours[day].hours.push({
    //     start: previousSlot ? previousSlot.start : '9:00 AM',
    //     end: previousSlot ? previousSlot.end : '5:00 PM'
    // })
}

const activeCloneDay = ref('')

const toggleCloneDay = (day) => {
    if(activeCloneDay.value == day) {
        activeCloneDay.value = ''
    } else {
        activeCloneDay.value = day
    }
}
import CloneSlot from './CloneSlot.vue'
</script>

<template>
    <form @submit.prevent="saveBusinessHours">
        <Card cardClass="gap-5 mb-5 !p-4">
            <template #default>
                <div class="flex flex-col gap-3">
                    <!-- working day item -->
                    <div v-for="(schedules, day) in $settings.businessHours" :key="index" class="flex flex-col md:flex-row items-start justify-between gap-5 md:gap-10 transition-all pb-3 border-b last:border-b-0 border-b-[#D0D5DD]">
                        <Toggle @click="toggleSchedule(day)" :checked="isScheduleEnabled(schedules.enabled)" class="w-[220px] mt-3">{{ day }}</Toggle>

                        <div v-if="!isScheduleEnabled(schedules.enabled)" class="w-[284px] text-[#98A2B3] text-base font-medium h-[41px] flex items-center">Unavailable</div>
                        <div v-else class="flex flex-col justify-between w-full gap-2 md:flex-row">
                            <div class="flex flex-col gap-3 overflow-scroll md:overflow-visible">
                                <div v-if="schedules.hours" v-for="(slot, index) in schedules.hours" :key="index" class="flex items-center gap-3 w-[284px]">

                                    <TimePicker v-model="slot.start" class="w-[110px]" placeholder="From" format="12" />
                                    -
                                    <TimePicker v-model="slot.end" class="w-[110px]" placeholder="To" format="12" />

                                    <Icon @click="removeSlot(day, index)" name="trash01" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer" />
                                </div>
                                <!-- <div v-else class="flex items-center h-full">
                                                <Button size="xs" type="secondary_color" @click="schedules.hours = schedules.hours || [], schedules.hours.push({ start: '', end: '' })">
                                                    <Icon name="plus" />Add first slot
                                                </Button>
                                            </div> -->
                            </div>
                            <div class="flex gap-2">
                                <Icon @click="addSlot(day)" name="plus" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer md:mt-3" />
                                <!-- <div>
                                    <Icon @click="cloneSlot(day)" name="copy06" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer md:mt-3" />
                                    <div>

                                    </div>
                                </div> -->
                                <!-- <Dropdown :contentClass="`border border-[#EAECF0] shadow-lg px-1 ${$settings.isRTL ? 'left-0' : 'right-0'}`" :clickToClose="false" :escToClose="false">
                                    <Icon name="copy06" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer md:mt-3" />

                                    <template #content>
                                        <div class="flex flex-col gap-1">
                                           <Checkbox  v-for="day in weekDays" :key="day.value" :value="day.value" :checked="selectedDays.includes(day.value)" @click.prevent="selectDays(day.value)">
                                                    <div class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                        <div class="text-[#344054] text-sm font-medium">{{ day.label }}</div>
                                                    </div>
                                                </Checkbox>
                                            <Button size="sm" classButton="!py-1" @click="cloneSlot(day)">Apply</Button>
                                        </div>
                                    </template>
                                </Dropdown> -->
                               <div class="relative">
                                    <Icon name="copy06" size="20px" class="text-[#667085] hover:text-[#2b2c30] cursor-pointer md:mt-3" @click="toggleCloneDay(day)" />
                                    <CloneSlot v-if="activeCloneDay==day" :day="day" @apply="(d,selectedDays)=>cloneSlot(d,selectedDays)" />
                               </div>
                            </div>
                        </div>

                    </div>
                </div>
            </template>
        </Card>
    </form>
</template>

<style>

</style>